// ReportPricecell Component

import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styled from 'styled-components'
import { clearfix } from '../../../../components/common.js'
import CellContainer from '../../../../components/ListCell/CellContainer.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'

const colors = {
  error: '#ff6565',
  success: '#7abd9a'
}

const PriceCellWrap = styled.div`
  ${clearfix};
  ${({ hasTooltip, status }) => `
    ${status ? `color: ${colors[status]};` : ''}
    ${hasTooltip ? 'overflow: visible;' : ''}
  `}
  float: left;
`

PriceCellWrap.propTypes = {
  hasTooltip: PropTypes.bool,
  status: PropTypes.string
}

const ActionWrap = styled.div`
  display: inline-block;
  float: right;
  margin-right: 7px;
`

const PriceWrap = styled.span`
  display: inline-block;
  float: left;
  text-align: left;
`

const DetailsContainer = styled.div`
  ${clearfix};
  display: block;
`

class ReportPriceCell extends Component {
  static propTypes = {
    price: PropTypes.number,
    width: PropTypes.string,
    showtooltip: PropTypes.bool,
    formatOverdue: PropTypes.bool,
    formatMargin: PropTypes.bool,
    baseTotal: PropTypes.number,
    tooltip: PropTypes.string,
    tooltipData: PropTypes.object
  }

  static defaultProps = {
    price: 0,
    width: '',
    showtooltip: false,
    formatOverdue: false,
    formatMargin: false,
    baseTotal: 0,
    tooltip: '',
    tooltipData: {}
  }

  render () {
    const { width } = this.props
    return <CellContainer width={width}>{this.renderItems()}</CellContainer>
  }

  renderItems () {
    const {
      price,
      tooltip,
      formatOverdue,
      formatMargin,
      baseTotal
    } = this.props
    let status = ''

    if (formatOverdue && price > baseTotal) {
      status = 'error'
    }

    if (formatMargin) {
      if (price >= baseTotal) {
        status = 'success'
      } else {
        status = 'error'
      }
    }

    return (
      <PriceCellWrap status={status} hasTooltip={Boolean(tooltip)}>
        <span className='cont'>
          {tooltip
            ? this.renderPriceWithTooltip()
            : this.renderPriceWithoutTooltip()}
        </span>
      </PriceCellWrap>
    )
  }

  renderPriceWithTooltip = () => {
    const { price, tooltip, tooltipData } = this.props
    return (
      <DetailsContainer>
        <PriceWrap>
          <PriceText value={price} />
        </PriceWrap>
        <ActionWrap>
          <IconButton
            icon='list-info'
            canHover
            tooltip={tooltip}
            tooltipData={tooltipData}
            tooltipPosition='top'
            size='small'
          />
        </ActionWrap>
      </DetailsContainer>
    )
  }

  renderPriceWithoutTooltip = () => {
    const { price } = this.props
    return (
      <PriceWrap>
        <PriceText value={price} />
      </PriceWrap>
    )
  }
}

export default ReportPriceCell
